import React from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Compass,
  Handshake,
  Shield,
  Award,
  Sailboat,
  ChevronRight,
  UsersRound,
  Briefcase,
  ArrowRight,
  CheckCircle2,
  MapPinned , HeartHandshake, Building2
} from "lucide-react";
import { BadgeCheck, PartyPopper, Sparkles, Globe, Waves } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";

const corporateNetworkingFaqs = [
  {
    question: "What is a corporate networking event on a yacht in Mumbai?",
    answer:
      "A corporate networking event on a yacht in Mumbai is a premium business gathering on the water designed for client hosting, executive interaction, partner engagement and professional relationship-building."
  },
  {
    question: "Why is a yacht good for business networking?",
    answer:
      "A yacht creates a more premium, memorable and private setting than a routine venue, which helps guests feel more engaged and leaves a stronger business impression."
  },
  {
    question: "What is the difference between a corporate networking event and a regular business event?",
    answer:
      "A regular business event is usually hosted in a standard venue, while a networking event on a yacht turns the gathering into a premium hosted experience that feels more exclusive and more memorable."
  },
  {
    question: "What happens during a corporate networking event on a yacht?",
    answer:
      "The event may include welcome hosting, networking, partner interaction, client conversations, executive engagement and premium business hospitality in a private setting."
  },
  {
    question: "Is this suitable for client hosting and partner meetings?",
    answer:
      "Yes. Corporate networking events on a yacht work especially well for client appreciation, partner interaction and premium business relationship-building."
  },
  {
    question: "What business goals can a corporate networking event support?",
    answer:
      "It can support client hosting, executive networking, partner engagement, investor interaction, business hospitality and stronger brand-led relationship-building."
  },
  {
    question: "How is Indiaboats different for corporate networking events?",
    answer:
      "Indiaboats focuses on premium on-water corporate experiences and helps companies create networking events that feel polished, meaningful and memorable."
  },
  {
    question: "How do I enquire about a corporate networking event in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, guest profile and event objective."
  }
];

const CorporateNetworking = () => {
  const highlights = [
    {
      text: "Premium corporate sailing regatta experiences in Mumbai",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M22 3c-1.1 0-2 1.2-2 2.5V17c0 .8-.4 1.5-1 2H5c-.6-.5-1-1.2-1-2V5.5C4 4.2 3.1 3 2 3" />
          <path d="M4 17a4 4 0 0 1 8 0v2" />
          <path d="M12 17a4 4 0 0 1 8 0v2" />
        </svg>
      )
    },
    {
      text: "Strong fit for team building and leadership development",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      text: "More engaging than routine corporate outings",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      )
    },
    {
      text: "Scenic and memorable on-water environment",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M2 10c3 0 3-3 6-3s3 3 6 3 3-3 6-3 3 3 6 3" />
          <path d="M2 17c3 0 3-3 6-3s3 3 6 3 3-3 6-3 3 3 6 3" />
        </svg>
      )
    },
    {
      text: "Better team participation and recall value",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      )
    },
    {
      text: "Experience-led planning and premium execution",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      )
    }
  ];

  const businessNauticalOptions = [
  {
    type: "networking type",
    badge: "Recommended",
    title: "Corporate Networking Events",
    desc: "Best for client hosting, executive networking, partner interaction and premium business hospitality.",
    linkText: "Explore Networking Events",
    linkUrl: "/corporate-networking-events",
    icon: <Handshake size={22} />,
  },
  {
    type: "regatta",
    badge: "Team Building",
    title: "Corporate Sailing Regattas",
    desc: "Ideal for team building, collaboration, leadership development and active participation on the water.",
    linkText: "Explore Sailing Regattas",
    linkUrl: "/corporate-sailing-regattas",
    icon: <Sailboat size={22} />,
  },
  {
    type: "celebration",
    badge: "Celebrations",
    title: "Corporate Parties & Awards",
    desc: "Perfect for company celebrations, employee recognition, awards ceremonies and internal gatherings.",
    linkText: "Explore Corporate Parties",
    linkUrl: "/corporate-yacht-parties",
    icon: <PartyPopper size={22} />,
  },
];
  
   const benefitsList = [
  "Client appreciation events",
  "Partner meetings and business gatherings",
  "Executive networking events",
  "Founder and investor interaction",
  "Leadership hosting",
  "Premium brand and relationship events",
  "Industry mixers and curated business gatherings",
  "Companies wanting stronger guest impression"
];

 const outcomes = [
  {
    text: "Client Hosting",
    description:
      "Host clients in a premium yacht setting that strengthens relationships and creates lasting business impressions.",
    icon: <Handshake size={20} />,
  },
  {
    text: "Partner Collaboration",
    description:
      "Bring together business partners for productive meetings and meaningful collaboration in an exclusive environment.",
    icon: <UsersRound size={20} />,
  },
  {
    text: "Executive Networking",
    description:
      "Create opportunities for senior leaders to network, exchange ideas and build valuable professional connections.",
    icon: <Briefcase size={20} />,
  },
  {
    text: "Founder Interaction",
    description:
      "Facilitate conversations between founders, investors and key stakeholders in a relaxed yet professional atmosphere.",
    icon: <Building2 size={20} />,
  },
  {
    text: "Community Engagement",
    description:
      "Strengthen your presence within the business community through premium networking experiences on the water.",
    icon: <Globe size={20} />,
  },
  {
    text: "Brand Hospitality",
    description:
      "Deliver exceptional brand-led hospitality experiences that leave guests feeling valued and appreciated.",
    icon: <BadgeCheck size={20} />,
  },
  {
    text: "Guest Engagement",
    description:
      "Keep guests engaged with a memorable onboard experience that encourages genuine interaction and conversation.",
    icon: <HeartHandshake size={20} />,
  },
  {
    text: "Business Impression",
    description:
      "Create stronger recall, meaningful conversations and a lasting impression that supports long-term business relationships.",
    icon: <Sparkles size={20} />,
  },
];

  return (
    <div>
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="csrh-master-wrapper">
        
        <div className="csrh-absolute-bg" style={{backgroundImage:'url(/assets/img/networking1.png)'}}></div>
        <div className="csrh-absolute-overlay"></div>

        {/* Relative Content Area */}
        <div className="csrh-content-container">
          {/* Centered Editorial Header Section */}
          <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              What Is a Corporate Networking Event   <br />
              <span className="csrh-title-italic">
              on a Yacht
              </span>
            </h1>
           
          </div>

          {/* Narrative Copy Layout Grid */}
          <div className="csrh-narrative-grid">
            {/* Left Narrative Column */}
            <div className="csrh-narrative-column csrh-border-right">
              {/* Card block for Paragraph 1 */}
              <div className="csrh-text-card">
                {/* <div className="csrh-card-icon-box">
                  <Users size={20} />
                </div> */}
                <div className="csrh-card-body">
                  {/* <h3 className="csrh-card-subtitle">
                    Active Collaboration Format
                  </h3> */}
                  <p className="csrh-p-lead">
                   A corporate networking event on a yacht is a premium business gathering held on the water where companies host clients, partners, leadership groups, founders, investors or business communities in a more exclusive and memorable setting.
                   In simple terms, it is a corporate networking format built around a yacht experience. Instead of inviting guests to a routine restaurant, hotel lounge or banquet venue, the company hosts them in a private and scenic environment on the water. This immediately changes how the event feels. It feels more premium, more thoughtful and more memorable.
                  </p>
                </div>
              </div>

              {/* Card block for Paragraph 2 */}
              {/* <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Wind size={20} />
                </div>
                <div className="csrh-card-body">
                  <h3 className="csrh-card-subtitle">
                    Live Decision-Making Environment
                  </h3>
                  <p className="csrh-p-body">
                    In simple terms, it is a corporate event built around
                    sailing. Instead of sitting through a routine offsite or
                    attending a passive team outing, participants work together
                    in a live environment where communication, coordination and
                    decision-making matter. The experience is designed to be
                    engaging, memorable and highly interactive.
                  </p>
                </div>
              </div> */}
            </div>

            {/* Right Narrative Column */}
            <div className="csrh-narrative-column">
              {/* Card block for Paragraph 3 */}
              <div className="csrh-text-card csrh-premium-highlight">
                {/* <div className="csrh-card-icon-box csrh-accent-icon">
                  <Anchor size={20} />
                </div> */}
                <div className="csrh-card-body">
                  {/* <h3 className="csrh-card-subtitle csrh-accent-text">
                    Why It Matters in Mumbai
                  </h3> */}
                  <p className="csrh-p-body">
                    A corporate networking event in Mumbai works especially well because it gives businesses a setting that supports relationship-building, guest comfort and stronger brand impression. The event becomes more than just a meeting or mixer. It becomes a hosted experience that reflects well on the company and leaves a lasting impression on the people attending.
                  </p>
                </div>
              </div>

              {/* Card block for Paragraph 4 */}
              <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Award size={20} />
                </div>
                <div className="csrh-card-body">
                  {/* <h3 className="csrh-card-subtitle">
                    The Indiaboats Operational Guarantee
                  </h3> */}
                  <p className="csrh-p-body">
                   With Indiaboats, corporate networking events on a yacht become premium business experiences that feel polished, memorable and professionally managed from start to finish.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Footer Bar */}
          <div className="csrh-action-footer">
            <div className="csrh-trust-indicators">
              <div className="csrh-trust-pill">
                <Shield size={14} className="csrh-pill-icon" />
                <span>National Safety Protocols</span>
              </div>
              <div className="csrh-trust-pill">
                <Compass size={14} className="csrh-spin-slow csrh-pill-icon" />
                <span>Expert Skipper Command</span>
              </div>
            </div>

            <button className="csrh-premium-btn">
              <span>Enquire About Corporate Party Yachts</span>
              <div className="csrh-btn-arrow-wrap">
                <ChevronRight size={14} />
              </div>
            </button>
          </div>
        </div>
      </section>

      <section className="csrw-master-section">
        <div className="csrw-container">
          {}
          {/* Editorial Section Header */}
          <div className="csrw-header-block">
            <h2 className="csrw-section-title">
              How a Corporate Networking Event  {" "}
              <span className="csrw-serif-italic">
                on a Yacht Works
              </span>
            </h2>
           
          </div>

          {}
          {/* Chronological Process Grid */}
          <div className="csrw-process-flow" id="cp-process-flow">
            {/* Step 1 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                  <MapPinned size={20} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">Premium Venue</h3>
                <p className="csrw-card-text">
                 A corporate networking event on a yacht is usually organised as a hosted business gathering where the yacht serves as the venue and the experience becomes part of the interaction.
                </p>
              </div>
            </div>

            {/* Step 2 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                <Sparkles size={20} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">Business Connections</h3>
                <p className="csrw-card-text">
                  The event often begins with guest arrival and welcome hosting, followed by networking, conversation and business interaction in a more relaxed but still premium setting. Depending on the purpose of the event, the format may include partner engagement, client appreciation, founder networking, executive discussions or relationship-building with important business stakeholders.
                </p>
              </div>
            </div>

            
          </div>

          {/* Value Takeaway Banner */}
          <div className="csrw-takeaway-banner">
            <div className="csrw-banner-inner" id="cp-banner-inner">
              <div className="csrw-banner-icon-area">
                <CheckCircle2 size={32} className="csrw-check-icon" />
              </div>
              <div className="csrw-banner-content">
               
                <p className="csrw-banner-text">
                 Recognition feels better when the setting feels special.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

        <section className="wcre-brutalist-wrapper">
        <div className="wcre-editorial-container">
          {}
          {/* Header block with solid bottom grid line */}
          <div className="wcre-main-header-block">
            <h2 className="wcre-giant-title">
              Why Corporate Networking Events on a Yacht Are So Effective
            </h2>
          </div>

          {}
          {/* Row 1: Left Image, Right text block */}
          <div className="wcre-grid-row wcre-row-one">
            {/* Row 1 Left: High-performance Yacht Image */}
            <div className="wcre-grid-cell wcre-cell-image">
              <div className="wcre-img-wrapper">
                <img
                  src="assets/img/networking3.png"
                  alt="Corporate teams executing maneuvers in active regatta"
                  className="wcre-grid-img"
                />
              </div>
            </div>

            {/* Row 1 Right: Deep prose on active collaboration */}
            <div className="wcre-grid-cell wcre-cell-prose">
              <div className="wcre-prose-inner">
                <h3 className="wcre-cell-heading">Professional Balance</h3>
                <p className="wcre-cell-paragraph">
                  A corporate networking event on a yacht is highly effective because it combines business interaction with premium hospitality. Companies often want networking events to feel professional, but not stiff. A yacht helps create exactly that balance.
                </p>
                
              </div>
            </div>
          </div>

          {}
          {/* Row 2: Left text block, Right Image */}
          <div className="wcre-grid-row wcre-row-two">
            {/* Row 2 Left: Narrative on De-Siloing & Trust */}
            <div className="wcre-grid-cell wcre-cell-prose">
              <div className="wcre-prose-inner">
                <h3 className="wcre-cell-heading">Stronger Engagement</h3>
                <p className="wcre-cell-paragraph">
                 The setting encourages better conversation because it feels more relaxed, more open and less routine than a standard corporate venue. Guests often feel more engaged, more comfortable and more impressed by the overall experience. This makes the event stronger not only from a hospitality point of view, but also from a business relationship point of view.
                </p>

                
              </div>
            </div>

            {/* Row 2 Right: Second Complementary Yachting Image */}
            <div className="wcre-grid-cell wcre-cell-image">
              <div className="wcre-img-wrapper">
                <img
                  src="assets/img/networking1.png"
                  alt="Yachts competing in perfect coordination on Mumbai waters"
                  className="wcre-grid-img"
                />
              </div>
            </div>
          </div>

          {}
          {/* Editorial trust footer bar structured like the bottom lines of the design layout */}
          <div className="wcre-grid-footer">
            <div className="wcre-footer-pill">
              <Shield size={14} />
              <span>Led by Champion Racing Skippers</span>
            </div>
            <div className="wcre-footer-pill">
              <Award size={14} />
              <span>Premium Experience Guarantee</span>
            </div>
          </div>
        </div>
      </section>

      <section className="csrb-root-wrapper" id="cn-root-wrapper">
      <div className="csrb-editorial-container">
        
        {}
        <div className="csrb-split-layout">
          
          {/* Left Column: Narrative Copy */}
          <div className="csrb-narrative-column">
            <h2 className="csrb-section-title">
              Who Corporate Networking Events   <span className="csrb-serif-italic">
                Are Best For
              </span>
            </h2>
            <div className="csrb-title-divider"></div>
            <p className="csrb-lead-paragraph">
             Corporate networking events on a yacht work especially well for businesses that want stronger business relationships and better hospitality value. They are ideal for companies looking to host in a more impressive and more memorable setting.
            </p>
          </div>

          {/* Right Column: Premium Interactive List */}
          <div className="csrb-list-column">
            <span className="csrb-list-eyebrow">GOOD FOR</span>
            <ul className="csrb-list">
              {benefitsList.map((item, index) => (
                <li key={index} className="csrb-list-item">
                  <div className="csrb-bullet-wrapper">
                    {/* Minimalist modern checkmark icon inside a subtle geometric container */}
                    <svg 
                      className="csrb-bullet-icon" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="csrb-item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
      </section>

       <section className="rse-root-wrapper">
        <div className="rse-editorial-container">
          {/* Section Header */}
          <div className="rse-header-block">
            <h2 className="rse-section-title">
              What Business Goals a Corporate Networking  {" "}
              <span className="rse-serif-italic">Event Can Support</span>
            </h2>
            <div className="rse-header-divider"></div>
            <p className="rse-section-paragraph">
            A corporate networking event in Mumbai can support a range of business goals depending on the audience and purpose of the event.
            </p>
          </div>

          {/* Minimalist Editorial List Layout (Replaces the Bento Grid) */}
          <div className="rse-outcomes-list">
            {outcomes.map((item, index) => (
              <div key={index} className="rse-outcome-list-item">
                <div className="rse-item-main-content">
                  {/* Clean, minimalist circular icon container */}
                  <div className="rse-icon-circle">{item.icon}</div>

                  {/* Vertical text stack with clean hierarchy */}
                  <div className="rse-text-stack">
                    <h3 className="rse-item-title">{item.text}</h3>
                    <p className="rse-item-desc">{item.description}</p>
                  </div>
                </div>

                {/* Dynamic decorative element that shifts on row hover */}
                {/* <div className="rse-item-action">
                  <span className="rse-action-badge">Development Goal</span>
                  <ArrowRight size={16} className="rse-arrow-icon" />
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>

        <section className="wefl-pre-root-wrapper">
        <div className="wefl-pre-editorial-container">
          <div className="wefl-pre-split-layout">
            {/* Left Column: Rich Editorial Copy */}
            <div className="wefl-pre-narrative-column">
              <div className="wefl-pre-header-block">
                <h2 className="wefl-pre-section-title">
                  What the Experience &nbsp;
                  <span className="wefl-pre-serif-italic">Feels Like</span>
                </h2>
                <div className="wefl-pre-header-divider"></div>
              </div>

              <div className="wefl-pre-text-block wefl-pre-highlight-block">
                <div className="wefl-pre-accent-stripe"></div>
                <p className="wefl-pre-paragraph-lead">
                A corporate networking event on a yacht feels polished, exclusive and more memorable than a standard business gathering. The atmosphere is very different from a hotel lobby, restaurant or banquet hall. Once guests step onboard, the environment immediately feels more premium and more considered.
                </p>
                
              </div>

              <div className="wefl-pre-text-block">
                <p className="wefl-pre-paragraph">
                 There is privacy, scenic value and a stronger sense of occasion, which helps the event feel more distinctive. For many businesses, that is what makes the experience stand out. It feels rewarding because guests are not just attending a networking event — they are part of a premium hosted experience.
                </p>
              </div>

              

              {/* Subtle Features List below text for high-end feel */}
              {/* <div className="wefl-pre-features-list">
                <div className="wefl-pre-feature-item">
                  <Wind size={18} className="wefl-pre-feature-icon" />
                  <span>Energising Setting</span>
                </div>
                <div className="wefl-pre-feature-item">
                  <Compass size={18} className="wefl-pre-feature-icon" />
                  <span>Active Presence</span>
                </div>
                <div className="wefl-pre-feature-item">
                  <Waves size={18} className="wefl-pre-feature-icon" />
                  <span>Premium Marine Edge</span>
                </div>
              </div> */}
            </div>

            {}
            <div className="wefl-pre-image-column">
              <div className="wefl-pre-image-wrapper">
                {/* Outer decorative border frame for editorial look */}
                {/* <div className="wefl-pre-image-accent-border"></div> */}

                {/* High-quality corporate/team sailing image */}
                <img
                  className="wefl-pre-main-image"
                  src="assets/img/networking4.png"
                  alt="Corporate team sailing on a premium yacht"
                />

                {/* Elegant Floating Stat Badge overlay on image */}
                <div className="wefl-pre-floating-badge">
                  <span className="wefl-pre-badge-title">Mumbai Harbour</span>
                  <span className="wefl-pre-badge-subtitle">
                    The Premium Alternative
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wpc-section-wrapper">
      {}
      <div className="wpc-container">
        <div className="wpc-grid">
          
          {/* Left Editorial Column: Copy Narratives */}
          <div className="wpc-content-col">
           <div className="wefl-pre-header-block">
                <h2 className="wefl-pre-section-title">
                  Why Companies Choose Indiaboats for  {" "}
                  <span className="wefl-pre-serif-italic">Corporate Networking Events</span>
                </h2>
                <div className="wefl-pre-header-divider"></div>
              </div>
            
            <p className="wpc-paragraph">
              Indiaboats offers premium yacht experiences in Mumbai and helps companies create corporate networking events that feel smooth, refined and meaningful. We understand that a successful business event should not only look impressive, but also support better interaction, stronger hospitality and a lasting positive impression.
            </p>
            
            <p className="wpc-paragraph">
              That is why our focus is not only on the yacht itself, but also on the overall event experience. From helping you choose the right format for your guests to making the event feel premium and professionally managed, Indiaboats helps businesses create networking events that truly stand out.
            </p>
          </div>

          {}
          {/* Right Column: Custom Interactive Highlights */}
          <div className="wpc-highlights-col">
            
            {/* Highlight 1 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M2 21h20M19.307 10.612a4 4 0 0 1-5.619 0L12 8.922l-1.688 1.69a4 4 0 0 1-5.619 0a4 4 0 0 1 0-5.62l1.688-1.69L12 1.613l5.619 5.62l1.688 1.69a4 4 0 0 1 0 5.619z" />
                  <path d="M12 8.922v12M8 15h8" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Premium corporate networking events in Mumbai</h3>
              </div>
            </div>

            {/* Highlight 2 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <circle cx="12" cy="8" r="7" />
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Strong fit for client hosting and business relationship-building</h3>
              </div>
            </div>

            {}
            {/* Highlight 3 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">More memorable than routine venues</h3>
              </div>
            </div>

            {/* Highlight 4 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v8M8 12h8" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Scenic and exclusive on-water setting</h3>
              </div>
            </div>

            {}
            {/* Highlight 5 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M12 2a10 10 0 0 0-10 10c0 5.523 4.477 10 10 10s10-4.477 10-10A10 10 0 0 0 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Better guest impression and recall value</h3>
              </div>
            </div>

            {/* Highlight 6 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Experience-led planning and premium execution</h3>
              </div>
            </div>

            {/* Highlight 7 */}
            <div className="wpc-highlight-card">
              <div className="wpc-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wpc-svg-icon">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
              </div>
              <div className="wpc-highlight-text-box">
                <h3 className="wpc-highlight-title">Professional and smooth event coordination</h3>
              </div>
            </div>

          </div>

        </div>
      </div>
      </section>

       <section className="crvs-section">
      <div className="crvs-container">
        
        {}
        <h2 className="crvs-main-heading">
          Corporate Networking Event vs Standard Business Venue
        </h2>

        {}
        <div className="crvs-comparison-grid">
          
          {/* Card 1: Standard Team Outing */}
         <div className="crvs-card crvs-card-muted">
  <div className="crvs-card-header">
    <div className="crvs-icon-wrapper crvs-icon-muted">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="crvs-svg-icon">
        <path d="M3 21h18" />
        <path d="M5 21V7l8-4 6 4v14" />
        <path d="M9 9h1" />
        <path d="M9 13h1" />
        <path d="M9 17h1" />
        <path d="M14 9h1" />
        <path d="M14 13h1" />
      </svg>
    </div>

    <h3 className="crvs-card-title crvs-title-muted">
      Standard Business Venue
    </h3>
  </div>

  <div className="crvs-card-content">
    <p className="crvs-paragraph">
      A standard business venue is often convenient, but it may not always create
      a strong impression.
    </p>

    <p className="crvs-paragraph">
      Instead of simply gathering guests in a predictable setting, the company creates a premium atmosphere that feels more distinctive and more memorable. Guests often engage more naturally, remember the event more clearly and associate it with better hospitality and stronger brand value.
    </p>

    <div className="crvs-divider"></div>

    <ul className="crvs-feature-list">
      <li className="crvs-feature-item">
        <span className="crvs-bullet crvs-bullet-muted"></span>
        Predictable meeting environment
      </li>

      <li className="crvs-feature-item">
        <span className="crvs-bullet crvs-bullet-muted"></span>
        Standard business hospitality
      </li>

      <li className="crvs-feature-item">
        <span className="crvs-bullet crvs-bullet-muted"></span>
        Limited guest recall
      </li>
    </ul>
  </div>
</div>

          {/* Card 2: Corporate Sailing Regatta */}
          <div className="crvs-card crvs-card-active">
  <div className="crvs-card-accent-glow"></div>

  <div className="crvs-card-header">
    <div className="crvs-icon-wrapper crvs-icon-active">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="crvs-svg-icon">
        <path d="M3 21h18" />
        <path d="M8 21V8l8-5v18" />
        <path d="M8 8l8 4" />
      </svg>
    </div>

    <h3 className="crvs-card-title crvs-title-active">
      Corporate Networking Event
    </h3>
  </div>

  <div className="crvs-card-content">
    <p className="crvs-paragraph">
      A corporate networking event on a yacht turns the event into a hosted
      experience rather than simply providing a meeting space.
    </p>

    <p className="crvs-paragraph">
      The premium atmosphere encourages better conversations, stronger business
      relationships and a more memorable brand impression for every guest.
    </p>

    <div className="crvs-divider"></div>

    <ul className="crvs-feature-list">
      <li className="crvs-feature-item">
        <span className="crvs-bullet crvs-bullet-active"></span>
        Premium hosted experience
      </li>

      <li className="crvs-feature-item">
        <span className="crvs-bullet crvs-bullet-active"></span>
        Stronger guest engagement
      </li>

      <li className="crvs-feature-item">
        <span className="crvs-bullet crvs-bullet-active"></span>
        Better recall and brand value
      </li>
    </ul>
  </div>
</div>

        </div>
      </div>
      </section>

      <section className="cxe-main-section">
      <div className="cxe-container">
        
       
        <div className="cxe-header-block">
          <div className="cxe-tag-row">
            <Shield size={14} className="cxe-shield-icon" />
            <span className="cxe-pre-title">Decision Framework</span>
          </div>
          <h2 className="cxe-section-title">
            Which Corporate Experience <span className="cxe-light-text">Is Right for Your Business</span>
          </h2>
          <p className="cxe-section-subtitle">
            Align your strategic organizational outcomes with our curated world-class marine formats.
          </p>
        </div>

        
        <div className="cxe-decision-grid" id="cp_decision_grid">
          {businessNauticalOptions.map((option, index) => {
            const isNetworking = option.type === "networking";
            return (
              <div 
                key={index} 
                className={`cxe-decision-card ${isNetworking ? 'cxe-card-dark' : 'cxe-card-light'}`}
              >
                <div className="cxe-card-accent-line"></div>
                
                <div className="cxe-card-header">
                  <div className="cxe-icon-box">
                    {option.icon}
                  </div>
                  <span className="cxe-card-badge">{option.badge}</span>
                </div>

                <div className="cxe-card-body">
                  <h3 className="cxe-card-title">{option.title}</h3>
                  <p className="cxe-card-desc">{option.desc}</p>
                </div>

                <div className="cxe-card-footer">
                  <a href={option.linkUrl} className="cxe-anchor-link">
                    <span>{option.linkText}</span>
                    <div className="cxe-arrow-wrapper">
                      <ArrowRight size={16} />
                    </div>
                  </a>
                </div>
              </div>
            );
          })}
        </div>

      </div>
      </section>

       <section className="wtei-section" id="cn_wtei_section">
      <div className="wtei-container">
        <div className="wtei-grid">
          
          
          <div className="wtei-col-left">
            <h2 className="wtei-title">
              What to Expect with Indiaboats
            </h2>
            <p className="wtei-paragraph">
              When you plan a corporate networking event with Indiaboats, the experience is designed to feel premium, polished and easy to organise. We help businesses understand what networking format suits their guest profile, brand tone and event objective so the final experience feels both effective and memorable.
            </p>
            
          </div>

          { }
         
          <div className="wtei-col-right">
            <ul className="wtei-list">
              
              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Premium corporate networking event experience in Mumbai</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Guidance based on guest type and business objective</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Supportive and experience-led planning</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Strong client-hosting and relationship-building format</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Scenic and memorable on-water environment</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Better impression than routine business venues</span>
              </li>

            </ul>
          </div>

        </div>
      </div>
      </section>

        <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Coordination and  <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every corporate networking event. We place strong emphasis on trained crew, responsible operations, guest support and professional coordination so your business event feels enjoyable, smooth and confidently managed.
          </p>
        </div>
      </div>
    </section> 

     <FAQSection
  title="Frequently Asked Questions About Corporate Events in Mumbai"
  faqData={corporateNetworkingFaqs}
/>
     
             <section className="btfUniqueSection" id='corporate_e_form'>
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Business Event</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Company Name</label>
      <input type="text" placeholder="Enter company name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Event Objective</label>
      <select>
        <option>Select event objective</option>
        <option>Client Appreciation</option>
        <option>Networking Evening</option>
        <option>Leadership Gathering</option>
        <option>Partner/Investor Meet</option>
        <option>Reward & Recognition</option>
        <option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your corporate event requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Proposal</span>
  </button>
</form>
        </div>
      </div>
    </section>

        
      <Footer />
    </div>
  );
};

export default CorporateNetworking;
